export default __webpack_public_path__ + "static/media/ftm_logo_dark.fe14b4d6.svg";